import type { AccountBase } from '@/models/AccountViewModel';
import type { HoldingViewModel } from '@/store/holdingsApi';
import type { HoldingAdvisorContext } from '../types';

interface BuildHoldingAdvisorContextParams {
  clientName: string | undefined;
  selectedHolding: HoldingViewModel | null;
  getAccountById: (accountId: number) => AccountBase | undefined;
  onClientNameClick: () => void;
}

/**
 * Builds the advisor-only header context for the Holding Details flyout.
 * Returns undefined for the end-user flyout (no clientName), so callers can
 * pass the result straight through as an optional prop.
 */
export function buildHoldingAdvisorContext({
  clientName,
  selectedHolding,
  getAccountById,
  onClientNameClick,
}: BuildHoldingAdvisorContextParams): HoldingAdvisorContext | undefined {
  if (!clientName) return undefined;

  return {
    clientName,
    isAum: selectedHolding
      ? getAccountById(selectedHolding.AccountId)?.IsHome
      : undefined,
    onClientNameClick,
  };
}
